import {isString} from "lodash"

/**
 * Shortens a value to a predefined length
 * @param {*} The value to shorten, the length, if it should have a
 * @returns {*} Either the shortened string or the original value if it's not a string
 */
export const maxLengthString = ({value = "", length = 100, elipsis = true}) => {
  if (!isString(value)) {
    return value
  }

  if (value.length < length) { return value }

  const l = elipsis ? (length - 3) : length
  let updatedValue = value.substr(0, l)

  if (elipsis) {
    updatedValue = `${updatedValue}...`
  }

  return updatedValue
}
